export * from './schema';
export var EName;
(function (EName) {
    EName["CommonName"] = "CN";
    EName["Country"] = "C";
    EName["Region"] = "L";
    EName["State"] = "ST";
    EName["Organization"] = "O";
    EName["OrganizationUnit"] = "OU";
})(EName || (EName = {}));
